import { MutationTree } from 'vuex';
import { PipelineState } from './state';

const mutations: MutationTree<PipelineState> = {
  SET_PIPELINE(state, { id, currentState }: PipelineState) {
    state.id = id;
    state.currentState = currentState;
  },
};

export default mutations;
